<template>
  <div>
    <section-separator size="lg" has-border class="mb-3">
      {{$t('settings.segments.tabs.jobs')}}
    </section-separator>
    <data-table :entity="entity"
                :data="jobBoards"
                :local-data="true"
                :columns="columns"
                :disable-permission-checks="true"
                :go-to-details-on-row-click="false"
                operations=""
                ref="table">
      <template slot="name" slot-scope="{row}">
        {{row.name}}
      </template>

      <base-switch slot="status" slot-scope="{row}"
                   :value="row.status === 'active'"
                   @input="(val) => onSwitchChange(row, val)"
      />
    </data-table>
  </div>
</template>
<script>
  import SegmentGroupService from 'src/services/SegmentGroupService';
  import entities from 'src/config/entities'

  export default {
    name: 'segments-job-board-settings',
    props: {
      segment: {
        type: Object,
        default: () => ({})
      },
      jobBoards: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        entity: entities.JOB_BOARD
      }
    },
    computed: {
      columns () {
        return [
          {
            prop: 'name',
            label: this.$t('settings.segments.labels.jobBoard'),
            minWidth: '200px',
            sortable: true
          },
          {
            prop: 'status',
            label: this.$t('settings.segments.labels.status'),
            minWidth: '200px',
            sortable: true
          }

        ]
      }
    },
    methods: {
      async onSwitchChange(row, value) {
        let segment_group_id = this.$route.params.id;
        let job_board_id = row.id;
        let data = {
          segment_group_id,
          job_board_id
        }
        if(value) {
          let result = await SegmentGroupService.createSegmentForJobBoard(data);
          if(result) {
            row.status = 'active';
          }
        } else {
          let result = await SegmentGroupService.deleteSegmentGroupForJobBoard(data);
          if(result) {
            row.status = '';
          }
        }
      }
    }
  }
</script>
<style>
</style>
